var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkshopActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6 9.72043C18.79 9.72043 18.05 8.44042 18.95 6.87042C19.47 5.96042 19.16 4.80042 18.25 4.28042L16.52 3.29042C15.73 2.82042 14.71 3.10042 14.24 3.89042L14.13 4.08042C13.23 5.65042 11.75 5.65042 10.84 4.08042L10.73 3.89042C10.28 3.10042 9.26 2.82042 8.47 3.29042L6.74 4.28042C5.83 4.80042 5.52 5.97042 6.04 6.88042C6.95 8.44042 6.21 9.72043 4.4 9.72043C3.36 9.72043 2.5 10.5704 2.5 11.6204V13.3804C2.5 14.4204 3.35 15.2804 4.4 15.2804C6.21 15.2804 6.95 16.5604 6.04 18.1304C5.52 19.0404 5.83 20.2004 6.74 20.7204L8.47 21.7104C9.26 22.1804 10.28 21.9004 10.75 21.1104L10.86 20.9204C11.76 19.3504 13.24 19.3504 14.15 20.9204L14.26 21.1104C14.73 21.9004 15.75 22.1804 16.54 21.7104L18.27 20.7204C19.18 20.2004 19.49 19.0304 18.97 18.1304C18.06 16.5604 18.8 15.2804 20.61 15.2804C21.65 15.2804 22.51 14.4304 22.51 13.3804V11.6204C22.5 10.5804 21.65 9.72043 20.6 9.72043ZM12.5 15.7504C10.71 15.7504 9.25 14.2904 9.25 12.5004C9.25 10.7104 10.71 9.25042 12.5 9.25042C14.29 9.25042 15.75 10.7104 15.75 12.5004C15.75 14.2904 14.29 15.7504 12.5 15.7504Z",
    fill: "url(#paint0_linear_4943_61705)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4943_61705",
    x1: 12.505,
    y1: 3.06152,
    x2: 12.505,
    y2: 21.9393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A79D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EC282"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkshopActive);
export default __webpack_public_path__ + "static/media/workshop-active.a190fca2a4b3a8d01dcc5c20f10080de.svg";
export { ForwardRef as ReactComponent };